const AuthForm = (props) => {
  const { title, subtitle, form } = props;
  return (
    <div className="card auth-card">
      <div className="card-body px-3 py-5">
        <div className="mx-auto mb-4 text-center auth-logo">
          <a href="dashboard.html" className="logo-dark">
            <img
              src="/assets/images/logo-new.png"
              height="60"
              alt="logo dark"
            />
          </a>

          <a href="dashboard.html" className="logo-light">
            <img
              src="/assets/images/logo-new.png"
              height="60"
              alt="logo light"
            />
          </a>
        </div>

        <h2 className="fw-bold text-uppercase text-center fs-18">{title}</h2>
        <p className="text-muted text-center mt-1 mb-4">{subtitle}</p>
        {form()}
      </div>
    </div>
  );
};

export default AuthForm;
